import React from "react";
import InputField from "../Atoms/InputField";
import styles from "../../Styles/SearchInput.module.css";

const SearchInput = ({ selection, inputHandler }) => {
  const textInputHandler = (value) => {
    inputHandler({ input: value, type: selection });
  };
  return (
    <div className={styles.search_input}>
      <InputField
        input={textInputHandler}
        label={`Search Your Note by ${selection}`}
      />
    </div>
  );
};

export default SearchInput;
